import React from 'react';
import { Award, Handshake, Star, Users } from 'lucide-react';
import evrika from '../../Assets/Images/Sponsors/evrika.jpg';
import exposkills from '../../Assets/Images/Sponsors/exposkills.jpg';
import saturnskyline from '../../Assets/Images/saturnskyline.svg';
import adm from '../../Assets/Images/Sponsors/adm.png';
import sakha from '../../Assets/Images/Sponsors/sakhatransneftegas.png';
import sinetspark from '../../Assets/Images/Sponsors/sinetspark.png';
import mpitlogo from '../../Assets/Images/Sponsors/mpitlogo.png';
import synergylogo from "../../Assets/Images/Sponsors/synergylogo.png"
import './Sponsors.css';

const Sponsors = () => {
  const sponsorsData = [
    {
      title: "Оператор конкурса",
      items: [
        { logo: saturnskyline, name: "АНО «ЦЦТ «Горизонт Сатурна» Республики Саха (Якутия)", icon: <Star className="sponsor-icon" /> }
      ]
    },
    {
      title: "Генеральный Спонсор",
      items: [
        { logo: sinetspark, name: "БФ «Синет Спарк»", icon: <Award className="sponsor-icon" /> }
      ]
    },
    {
      title: "Спонсоры проекта",
      items: [
        // { logo: sakha, name: "АО «САХАТРАНСНЕФТЕГАЗ»", icon: <Handshake className="sponsor-icon" /> },
        // { logo: sinetspark, name: "Фонд «Sinet Spark»", icon: <Handshake className="sponsor-icon" /> }
      ]
    },
    {
      title: "Партнёры",
      items: [
        // { logo: exposkills, name: "IT Школа «ExpoSkills»", icon: <Users className="sponsor-icon" /> },
        { logo: evrika, name: "МБОУ «Районная Гимназия «Эврика»", icon: <Users className="sponsor-icon" /> },
        { logo: adm, name: "Администрация ГП «город Олёкминск»", icon: <Users className="sponsor-icon" /> },
        { logo: mpitlogo, name: "Всероссийский конкурс «Моя профессия – ИТ»", icon: <Users className="sponsor-icon" /> },
        // { logo: synergylogo, name: "АНО СПО «Цифровой колледж «Синергия»", icon: <Users className="sponsor-icon" /> }
      ]
    }
  ];

  return (
    <section id="Sponsors" className="sponsors-section">
      <div className="sponsors-header">
        <Handshake className="header-icon" size={40} />
        <h1>Партнёры и спонсоры</h1>
      </div>

      <div className="sponsors-grid">
        {sponsorsData.map((category, index) => (
          <div className="sponsor-category" key={index}>
            <h2 className="category-title">{category.title}</h2>
            <div className="sponsor-items">
              {category.items.map((sponsor, idx) => (
                <div className="sponsor-card" key={idx}>
                  <div className="sponsor-logo-container">
                    <img src={sponsor.logo} alt={sponsor.name} className="sponsor-logo" />
                    <div className="sponsor-icon-container">
                      {sponsor.icon}
                    </div>
                  </div>
                  <h4>{sponsor.name}</h4>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Sponsors;